import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { useSwipeable } from 'react-swipeable'
import SVG from 'react-inlinesvg'
import Member from './Member'
import Arrow from '../../assets/svg/down.svg'

const StyledWrapper = styled.div`
  margin: 0 auto;
  position: relative;
`

const StyledMemberList = styled.ul`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 400px;
  justify-content: center;
  left: 50%;
  margin-left: -285px;
  position: relative;
  transform: translate3d(
    ${({ activeMember }) =>
      activeMember === 0 ? '0' : `-${activeMember * 240}px`},
    0,
    0
  );
  transition: transform 0.4s ease;
  width: ${({ dataLength }) => dataLength * 240 + 330}px;

  ${({ theme }) => theme.media.desktop} {
    height: 504px;
    margin-left: -360px;
    transform: translate3d(
      ${({ activeMember }) =>
        activeMember === 0 ? '0' : `-${activeMember * 304}px`},
      0,
      0
    );
    width: ${({ dataLength }) => dataLength * 304 + 420}px;
  }
`

const StyledMemberListItem = styled.div`
  padding: 0 12px;
  transition: all 0.4s ease;

  ${({ isActive }) =>
    isActive
      ? css`
          height: 400px;
          width: 330px;
        `
      : css`
          height: 285px;
          width: 240px;
        `}

  ${({ theme }) => theme.media.desktop} {
    ${({ isActive }) =>
      isActive
        ? css`
            height: 504px;
            width: 420px;
          `
        : css`
            height: 360px;
            width: 304px;
          `}
  }
`

const StyledArrow = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  box-shadow: 0 3px 3px -1px rgba(10, 22, 70, 0.1),
    0 0 1px 0 rgba(10, 22, 70, 0.06);
  cursor: pointer;
  display: flex !important;
  height: 48px;
  justify-content: center;
  margin-top: -24px;
  position: absolute;
  top: 50%;
  width: 48px;

  ${({ dir }) =>
    dir === 'prev'
      ? css`
          left: 15px;
          z-index: 2000;

          .isvg {
            transform: rotate(90deg);
          }

          ${({ theme }) => theme.media.desktop} {
            left: 60px;
          }
        `
      : css`
          right: 15px;

          .isvg {
            transform: rotate(-90deg);
          }

          ${({ theme }) => theme.media.desktop} {
            right: 60px;
          }
        `}
`

const SlickArrow = ({ dir, onClick }) => (
  <StyledArrow dir={dir} onClick={onClick}>
    <SVG src={Arrow} />
  </StyledArrow>
)

const MemberList = ({ data, cmsData }) => {
  const standarizedData = []

  if (cmsData) {
    cmsData.items.map((item, index) => {
      item.fields.id = index
      standarizedData.push(item.fields)
      return null
    })
  }
  const MemberData = cmsData ? standarizedData : data

  const contentfulData = MemberData
  const [activeMember, setActiveMember] = useState(0)
  const handlers = useSwipeable({
    onSwiped: event => {
      event.dir === 'Right' && setPrevSlide()
      event.dir === 'Left' && setNextSlide()
    },
    config: {
      delta: 10,
      preventDefaultTouchmoveEvent: false,
      trackTouch: true,
      trackMouse: true,
      rotationAngle: 0,
    },
  })

  const setNextSlide = () => {
    activeMember !== contentfulData.length - 1 &&
      setActiveMember(activeMember + 1)
  }

  const setPrevSlide = () => {
    activeMember !== 0 && setActiveMember(activeMember - 1)
  }

  return (
    <StyledWrapper>
      <StyledMemberList
        activeMember={activeMember}
        dataLength={contentfulData.length}
        {...handlers}
      >
        {contentfulData.map((member, index) => {
          return (
            <StyledMemberListItem
              isActive={member.id === contentfulData[activeMember].id}
              key={member.id}
            >
              <Member
                data={member}
                isActive={member.id === contentfulData[activeMember].id}
                onClick={() => setActiveMember(index)}
              />
            </StyledMemberListItem>
          )
        })}
      </StyledMemberList>
      <SlickArrow dir="next" onClick={() => setNextSlide()} />
      <SlickArrow dir="prev" onClick={() => setPrevSlide()} />
    </StyledWrapper>
  )
}

export default MemberList
